import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  CloudUpload,
  Delete,
  Visibility,
  VisibilityOff,
  Settings,
} from "@mui/icons-material";
import ToggleSwitch from "../backend/ToggleSwitch";
import UseToast from "../UseToast";
import { useDropzone } from "react-dropzone";

const getFileType = (fileUrl) => {
  if (!fileUrl) return "blank"; // No URL provided

  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg"];
  const videoExtensions = [".mp4", ".mov", ".avi", ".mkv", ".webm"];

  if (imageExtensions.some((ext) => fileUrl.toLowerCase().endsWith(ext))) {
    return "image";
  }
  if (videoExtensions.some((ext) => fileUrl.toLowerCase().endsWith(ext))) {
    return "video";
  }
  return "other"; // Other file types or unsupported extensions
};

const MediaDropzone = ({ onDrop, selectedFile }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".gif"],
      "video/*": [".mp4", ".mov", ".mp3"],
      "application/pdf": [".pdf"],
    },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed #cccccc",
        padding: "20px",
        borderRadius: "5px",
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <input {...getInputProps()} />
      {selectedFile ? (
        <p>{selectedFile.name}</p>
      ) : (
        <p>Drag and drop a file here, or click to select a file</p>
      )}
    </div>
  );
};

const UploadButton = ({ uploading, onUpload, buttonColor, ...props }) => (
  <button
    onClick={onUpload}
    type="button"
    style={{
      marginTop: "20px",
      //   padding: "10px 20px",
      backgroundColor: buttonColor,
      // color: "#FFFFFF",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      ...props.style,
    }}
    disabled={uploading}
  >
    {uploading ? "Uploading..." : "Upload"}
  </button>
);

// UploadedUrl Component
const UploadedUrl = ({ url, uploadedUrls, handleDeleteLogo, logoState }) =>
  url ? (
    <div
      style={{
        marginTop: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start", // Adjust alignment of child elements (optional)
        gap: "10px", // Add spacing between child elements (optional)
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginTop: "15px",
        }}
      >
        <div>
          Uploaded File:{" "}
          <a
            href={url.fileUrl}
            style={{ fontWeight: "bold" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {url.fileName}
          </a>
        </div>

        {uploadedUrls.fileUrl && (
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleDeleteLogo(logoState)}
          >
            <Delete />
          </Button>
        )}
      </div>
      {/* <div style={{ float: 'right', width: '30%', textAlign: 'right' }}>
        {getFileType(url.fileUrl) === 'image' ? (
          // Render image if it's an image file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img src={url.fileUrl} style={{ maxWidth: '200px', maxHeight: '60px' }} alt="" />
          </a>
        ) : getFileType(url.fileUrl) === 'video' ? (
          // Render play button for video file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img
              src="https://paulavatar.s3.us-east-2.amazonaws.com/play-button.png"
              style={{ maxWidth: '200px', maxHeight: '60px' }}
              alt="Play Video"
            />
          </a>
        ) : (
          // Fallback for other cases
          ''
        )}
      </div> */}
    </div>
  ) : null;

const UploadedUrlImage = ({ url }) => {
  return (
    <>
      {url ? (
        <div style={{ margin: "auto" }}>
          {getFileType(url.fileUrl) === "image" ? (
            // Render image if it's an image file
            <a href={url.fileUrl} target="_blank" rel="noreferrer">
              <img
                src={url.fileUrl}
                style={{ maxWidth: "210px", maxHeight: "80px" }}
                alt=""
              />
            </a>
          ) : getFileType(url.fileUrl) === "video" ? (
            // Render play button for video file
            <a href={url.fileUrl} target="_blank" rel="noreferrer">
              <img
                src="https://paulavatar.s3.us-east-2.amazonaws.com/play-button.png"
                style={{ maxWidth: "200px", maxHeight: "60px" }}
                alt="Play Video"
              />
            </a>
          ) : (
            // Fallback for other cases
            ""
          )}
        </div>
      ) : null}
    </>
  );
};

export default function MainWayfinderMedia({
  type,
  userId,
  buttonColor,
  title,
  uploadedUrls,
  setUploadedUrls,
  uploadingStates,
  setUploadingStates,
  fetchCategoryData,
  loading,
  handleUpload,
  handleDeleteLogo,
  handleSave,
  handleToggleChangeMedia,
  showSaveBtn,
}) {
  console.log("Uploaded URLs in MainWayfinderMedia:", uploadedUrls);

  const [leftTopMedia, setLeftTopMedia] = useState(null);
  const [leftBottomMedia, setLeftBottomMedia] = useState(null);
  const [rightTopMedia, setRightTopMedia] = useState(null);
  const [rightBottomMedia, setRightBottomMedia] = useState(null);

  const [backButtonMedia, setBackButtonMedia] = useState(null);
  const [locationPhotoMedia, setLocationPhotoMedia] = useState(null);

  const createDropHandler = (setMedia) => (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setMedia(acceptedFiles[0]);
    }
  };

  const handleMediaWidthChange = (position, width) => {
    setUploadedUrls((prev) => {
      // Check if prev is a function (setItem) or an object (uploadedUrls)
      if (typeof prev === "function") {
        // This shouldn't happen, but handle it
        return prev;
      }

      // If prev has uploadedUrls property, it's the full item object
      if (prev.uploadedUrls) {
        return {
          ...prev,
          uploadedUrls: {
            ...prev.uploadedUrls,
            [position]: {
              ...prev.uploadedUrls[position],
              width: width,
            },
          },
        };
      }

      // Otherwise, it's just the uploadedUrls object
      return {
        ...prev,
        [position]: {
          ...prev[position],
          width: width,
        },
      };
    });
  };

  // Handle upload with AWS S3
  const handleUploadToS3 = async (file, position) => {
    if (!file) {
      return;
    }

    // Call the parent's handleUpload function which uses S3
    await handleUpload(file, position);
  };

  useEffect(() => {
    fetchCategoryData();
  }, [userId]);

  return (
    <Box style={{ padding: "20px", marginTop: "20px" }}>
      <form
        className="tab-wizard wizard-circle wizard vertical"
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
        }}
      >
        <div className="row">
          {/* Upper Left */}
          <div className="col-md-6 d-flex p-3">
            <div
              className={`form-group menu-card2 p-3 ${
                !uploadedUrls?.upperLeft?.enabled ? "disabled" : ""
              } h-100 w-100`}
            >
              <div className="form-group">
                <label>Upper Left Logo:</label>
                <ToggleSwitch
                  label="Enable"
                  isOn={uploadedUrls?.upperLeft?.enabled || false}
                  id={"upperLeft"}
                  onChange={(val) => handleToggleChangeMedia("upperLeft", val)}
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "5px",
                }}
              >
                <MediaDropzone
                  onDrop={createDropHandler(setLeftTopMedia)}
                  selectedFile={leftTopMedia}
                />
                <UploadedUrlImage url={uploadedUrls?.upperLeft} />
              </div>

              <div>
                <UploadedUrl
                  url={uploadedUrls?.upperLeft}
                  uploadedUrls={uploadedUrls?.upperLeft}
                  handleDeleteLogo={handleDeleteLogo}
                  logoState="upperLeft"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <UploadButton
                  uploading={uploadingStates?.upperLeft || false}
                  onUpload={() => handleUploadToS3(leftTopMedia, "upperLeft")}
                  buttonColor={buttonColor}
                  style={{ margin: "0" }}
                />

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "flex-end",
                  }}
                >
                  <label htmlFor="">Size (%):</label>
                  <input
                    type="number"
                    placeholder="Width"
                    value={uploadedUrls?.upperLeft?.width || ""}
                    onChange={(e) =>
                      handleMediaWidthChange("upperLeft", e.target.value)
                    }
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Upper Right */}
          <div className="col-md-6 d-flex p-3">
            <div
              className={`form-group menu-card2 ${
                !uploadedUrls?.upperRight?.enabled ? "disabled" : ""
              } h-100 w-100`}
            >
              <div className="form-group">
                <label>Upper Right Logo:</label>
                <ToggleSwitch
                  label="Enable"
                  isOn={uploadedUrls?.upperRight?.enabled || false}
                  id={"upperRight"}
                  onChange={(val) => handleToggleChangeMedia("upperRight", val)}
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "5px",
                }}
              >
                <MediaDropzone
                  onDrop={createDropHandler(setRightTopMedia)}
                  selectedFile={rightTopMedia}
                />
                <UploadedUrlImage url={uploadedUrls?.upperRight} />
              </div>

              <div>
                <UploadedUrl
                  url={uploadedUrls?.upperRight}
                  uploadedUrls={uploadedUrls?.upperRight}
                  handleDeleteLogo={handleDeleteLogo}
                  logoState="upperRight"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <UploadButton
                  uploading={uploadingStates?.upperRight || false}
                  onUpload={() => handleUploadToS3(rightTopMedia, "upperRight")}
                  buttonColor={buttonColor}
                  style={{ margin: "0" }}
                />

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "flex-end",
                  }}
                >
                  <label htmlFor="">Size (%):</label>
                  <input
                    type="number"
                    placeholder="Width"
                    value={uploadedUrls?.upperRight?.width || ""}
                    onChange={(e) =>
                      handleMediaWidthChange("upperRight", e.target.value)
                    }
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Left */}
          <div className="col-md-6 d-flex p-3">
            <div
              className={`form-group menu-card2 ${
                !uploadedUrls?.bottomLeft?.enabled ? "disabled" : ""
              } h-100 w-100`}
            >
              <div className="form-group">
                <label>Bottom Left Logo:</label>
                <ToggleSwitch
                  label="Enable"
                  isOn={uploadedUrls?.bottomLeft?.enabled || false}
                  id={"bottomLeft"}
                  onChange={(val) => handleToggleChangeMedia("bottomLeft", val)}
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "5px",
                }}
              >
                <MediaDropzone
                  onDrop={createDropHandler(setLeftBottomMedia)}
                  selectedFile={leftBottomMedia}
                />
                <UploadedUrlImage url={uploadedUrls?.bottomLeft} />
              </div>

              <div>
                <UploadedUrl
                  url={uploadedUrls?.bottomLeft}
                  uploadedUrls={uploadedUrls?.bottomLeft}
                  handleDeleteLogo={handleDeleteLogo}
                  logoState="bottomLeft"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <UploadButton
                  uploading={uploadingStates?.bottomLeft || false}
                  onUpload={() =>
                    handleUploadToS3(leftBottomMedia, "bottomLeft")
                  }
                  buttonColor={buttonColor}
                  style={{ margin: "0" }}
                />
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "flex-end",
                  }}
                >
                  <label htmlFor="">Size (%):</label>
                  <input
                    type="number"
                    placeholder="Width"
                    value={uploadedUrls?.bottomLeft?.width || ""}
                    onChange={(e) =>
                      handleMediaWidthChange("bottomLeft", e.target.value)
                    }
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Right */}
          <div className="col-md-6 d-flex p-3">
            <div
              className={`form-group menu-card2 ${
                !uploadedUrls?.bottomRight?.enabled ? "disabled" : ""
              } h-100 w-100`}
            >
              <div className="form-group">
                <label>Bottom Right Logo:</label>
                <ToggleSwitch
                  label="Enable"
                  isOn={uploadedUrls?.bottomRight?.enabled}
                  id={"bottomRight"}
                  onChange={(val) =>
                    handleToggleChangeMedia("bottomRight", val)
                  }
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "5px",
                }}
              >
                <MediaDropzone
                  onDrop={createDropHandler(setRightBottomMedia)}
                  selectedFile={rightBottomMedia}
                />
                <UploadedUrlImage url={uploadedUrls?.bottomRight} />
              </div>

              <div>
                <UploadedUrl
                  url={uploadedUrls?.bottomRight}
                  uploadedUrls={uploadedUrls?.bottomRight}
                  handleDeleteLogo={handleDeleteLogo}
                  logoState="bottomRight"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <UploadButton
                  uploading={uploadingStates?.bottomRight || false}
                  onUpload={() =>
                    handleUploadToS3(rightBottomMedia, "bottomRight")
                  }
                  buttonColor={buttonColor}
                  style={{ margin: "0" }}
                />

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "flex-end",
                  }}
                >
                  <label htmlFor="">Size (%):</label>
                  <input
                    type="number"
                    placeholder="Width"
                    value={uploadedUrls?.bottomRight?.width || ""}
                    onChange={(e) =>
                      handleMediaWidthChange("bottomRight", e.target.value)
                    }
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {type === "location" && (
            <>
              {/* <div className="col-md-6 d-flex p-3">
                <div
                  className={`form-group menu-card2 ${
                    !uploadedUrls?.backButton?.enabled ? 'disabled' : ''
                  } h-100 w-100`}
                >
                  <div className="form-group">
                    <label>Back Button:</label>
                    <ToggleSwitch
                      label="Enable"
                      isOn={uploadedUrls?.backButton?.enabled || false}
                      id={'backButton'}
                      onChange={val => handleToggleChangeMedia('backButton', val)}
                    />
                  </div>

                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: '5px',
                    }}
                  >
                    <MediaDropzone
                      onDrop={createDropHandler(setBackButtonMedia)}
                      selectedFile={backButtonMedia}
                    />
                    <UploadedUrlImage url={uploadedUrls?.backButton} />
                  </div>

                  <div>
                    <UploadedUrl
                      url={uploadedUrls?.backButton}
                      uploadedUrls={uploadedUrls?.backButton}
                      handleDeleteLogo={handleDeleteLogo}
                      logoState="backButton"
                    />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '10px',
                      alignItems: 'center',
                      marginTop: '20px',
                    }}
                  >
                    <UploadButton
                      uploading={uploadingStates?.backButton || false}
                      onUpload={() => handleUpload(backButtonMedia, 'backButton')}
                      buttonColor={buttonColor}
                      style={{ margin: '0' }}
                    />

                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        width: '40%',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <label htmlFor="">Size (%):</label>
                      <input
                        type="number"
                        placeholder="Width"
                        value={uploadedUrls?.backButton?.width || ''}
                        onChange={e => handleMediaWidthChange('backButton', e.target.value)}
                        style={{ width: '50%' }}
                      />
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="col-md-6 d-flex p-3">
                <div
                  className={`form-group menu-card2 ${
                    !uploadedUrls?.locationPhoto?.enabled ? "disabled" : ""
                  } h-100 w-100`}
                >
                  <div className="form-group">
                    <label>Location Photo:</label>
                    <ToggleSwitch
                      label="Enable"
                      isOn={uploadedUrls?.locationPhoto?.enabled || false}
                      id={"locationPhoto"}
                      onChange={(val) =>
                        handleToggleChangeMedia("locationPhoto", val)
                      }
                    />
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "5px",
                    }}
                  >
                    <MediaDropzone
                      onDrop={createDropHandler(setLocationPhotoMedia)}
                      selectedFile={locationPhotoMedia}
                    />
                    <UploadedUrlImage url={uploadedUrls?.locationPhoto} />
                  </div>

                  <div>
                    <UploadedUrl
                      url={uploadedUrls?.locationPhoto}
                      uploadedUrls={uploadedUrls?.locationPhoto}
                      handleDeleteLogo={handleDeleteLogo}
                      logoState="locationPhoto"
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "10px",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                  >
                    <UploadButton
                      uploading={uploadingStates?.locationPhoto || false}
                      onUpload={() =>
                        handleUploadToS3(locationPhotoMedia, "locationPhoto")
                      }
                      buttonColor={buttonColor}
                      style={{ margin: "0" }}
                    />

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        width: "40%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <label htmlFor="">Size (%):</label>
                      <input
                        type="number"
                        placeholder="Width"
                        value={uploadedUrls?.locationPhoto?.width || ""}
                        onChange={(e) =>
                          handleMediaWidthChange(
                            "locationPhoto",
                            e.target.value,
                          )
                        }
                        style={{ width: "50%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {showSaveBtn && (
          <div className="row pt-3">
            <div className="col-md-12">
              <Button
                type="submit"
                variant="contained"
                // onClick={handleSave}
                disabled={loading}
                sx={{
                  backgroundColor: buttonColor,
                  color: "white",
                  padding: "10px 30px",
                  "&:hover": { backgroundColor: buttonColor },
                }}
              >
                {loading ? "Saving..." : "Save All Media Settings"}
              </Button>
            </div>
          </div>
        )}
      </form>
    </Box>
  );
}
